<template>
  <v-container fluid class="checklist">
    <v-row>
      <v-col cols="12" md="12">
        <v-data-table
          :headers="headers"
          :items="checkList"
          class="mt-5"
          hide-default-footer
        >
          <template v-slot:[`item.ID`]="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
          <!--eslint-disable-next-line -->
          <template v-slot:[`item.checkListType`]="{ item }">
            <td>
              <h4 class="heading">
                {{ item.checkListType }}
              </h4>
              <span class="subtitle-2 grey--text">{{ item.description }}</span>
            </td>
          </template>
          <!--eslint-disable-next-line -->
          <template v-slot:[`item.pass`]="{ item }">
            <span>
              <v-icon color="warning">mdi-alert</v-icon>
              incomplete
            </span>
          </template>
          <!--eslint-disable-next-line -->
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              small
              :disabled="item.pass"
              :to="{
                name: 'ComponentCard',
                params: { name: item.checkListType },
              }"
              color="primary"
            >
              Complete
              <v-icon right> mdi-arrow-right </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AuthService } from "../../dashboard/modules/auth";
export default {
  name: "CheckListComponent",
  data: function () {
    return {
      headers: [
        {
          text: "S/N",
          align: "start",
          sortable: false,
          value: "ID",
        },
        {
          text: "Item",
          align: "start",
          sortable: false,
          value: "checkListType",
        },
        { text: "Status", value: "pass" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },

  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Checklist/getChecklist", {
        category:
          AuthService.user.student !== null
            ? AuthService.user.student.programmeStudentID.split("/")[0] ===
                "CPSPK" ||
              AuthService.user.student.programmeStudentID.split("/")[0] ===
                "CPSP"
              ? "CPSP-K"
              : "APS-K"
            : "APS-K",
        type: v.$route.params.type,
      });
    });
  },

  computed: {
    checkList() {
      return this.$store.getters["Checklist/checklist"].filter(
        (item) => !item.pass,
      );
    },
  },
};
</script>

<style scoped>
.checklist {
  background-color: #f4f5fa;
  font-family: "PT Sans Caption", sans-serif;
  cursor: progress;
}
</style>
